import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { AppDataProvider } from "@/context/AppDataContext";
import { msalConfig } from "../config/authConfig";
import { isOfflineMode } from "@/helpers/offlineMode";

const msalInstance = new PublicClientApplication(msalConfig);

export const Providers = ({ children }: { children: React.ReactNode }) => {
  if (isOfflineMode()) {
    return <AppDataProvider>{children}</AppDataProvider>;
  }

  return (
    <MsalProvider instance={msalInstance}>
      <AppDataProvider>{children}</AppDataProvider>
    </MsalProvider>
  );
};
